module.exports = __webpack_public_path__ + "static/media/022ty@3x.ae1b6c1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/022ty@3x.png
// module id = 1674
// module chunks = 0 1